import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-839a1edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  flat: "",
  bordered: ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text__title--medium",
  style: {"text-align":"center","width":"100%","margin-left":"25px"}
}, "Expeditii", -1))
const _hoisted_3 = { style: {"margin-left":"auto"} }
const _hoisted_4 = {
  key: 0,
  class: "material-icons",
  style: {"font-size":"2em","cursor":"pointer"}
}
const _hoisted_5 = {
  class: "table table-condensed",
  style: {"min-width":"400px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " Numar ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " Data ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " Detalii ", -1))
const _hoisted_9 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_10 = {
  key: 0,
  class: "text__label--thin",
  style: {"text-align":"center"}
}
const _hoisted_11 = { style: {"display":"flex","flex-direction":"row","flex-wrap":"wrap","min-height":"50px","max-height":"100px","max-width":"250px","width":"250px","overflow-y":"auto"} }
const _hoisted_12 = {
  key: 0,
  class: "material-icons cursor-pointer"
}
const _hoisted_13 = { style: {"font-size":"0.8em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loadingExpeditii)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "2em"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_card_section, { style: {"display":"flex"} }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  (_ctx.user.auth_for_expeditie=='y' && _ctx.isAllowOperator)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createTextVNode("local_shipping "),
                        (_ctx.user.auth_for_expeditie=='y')
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Adauga expeditie ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user.auth_for_expeditie=='y' && _ctx.isAllowOperator)
                    ? (_openBlock(), _createBlock(_component_q_popup_proxy, {
                        key: 1,
                        ref: "refNewExpeditie",
                        "transition-show": "scale",
                        "transition-hide": "scale",
                        style: {"min-width":"600px !important"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card, {
                            class: "my-card",
                            flat: "",
                            bordered: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Inregistrare Expeditie")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              _createVNode(_component_q_card_section, { horizontal: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("table", _hoisted_5, [
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", null, [
                                            _hoisted_6,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_input, {
                                                outlined: "",
                                                modelValue: _ctx.newExpeditie.awb_nr,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newExpeditie.awb_nr) = $event)),
                                                "lazy-rules": "",
                                                counter: "",
                                                maxlength: "30",
                                                dense: "",
                                                "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' }
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("tr", null, [
                                            _hoisted_7,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_input, {
                                                outlined: "",
                                                modelValue: _ctx.newExpeditie.awb_data,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newExpeditie.awb_data) = $event)),
                                                dense: "",
                                                mask: "##.##.####",
                                                "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                                style: {"max-width":"150px"}
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_q_icon, {
                                                    name: "event",
                                                    class: "cursor-pointer"
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_popup_proxy, {
                                                    ref: "qDateProxy1",
                                                    "transition-show": "scale",
                                                    "transition-hide": "scale"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_q_date, {
                                                        minimal: "",
                                                        modelValue: _ctx.newExpeditie.awb_data,
                                                        "onUpdate:modelValue": [
                                                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newExpeditie.awb_data) = $event)),
                                                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$refs['qDateProxy1'] as any).hide()))
                                                        ],
                                                        mask: "DD.MM.YYYY",
                                                        locale: _ctx.myLocale
                                                      }, null, 8, ["modelValue", "locale"])
                                                    ]),
                                                    _: 1
                                                  }, 512)
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("tr", null, [
                                            _hoisted_8,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_input, {
                                                class: "col-10",
                                                outlined: "",
                                                style: {"max-height":"10vh"},
                                                modelValue: _ctx.newExpeditie.awb_detalii,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newExpeditie.awb_detalii) = $event)),
                                                type: "textarea",
                                                "lazy-rules": "",
                                                counter: "",
                                                maxlength: "800",
                                                rows: "3",
                                                dense: "",
                                                "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' }
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_q_btn, {
                                  label: "Salveaza",
                                  size: "sm",
                                  type: "submit",
                                  color: "primary",
                                  onClick: _ctx.saveNewExpeditie
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  label: "Renunt",
                                  size: "sm",
                                  type: "reset",
                                  flat: "",
                                  onClick: _ctx.onCancel,
                                  style: {"margin-left":"5px"}
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, {
            class: "q-pt-none",
            style: {"margin":"0px","padding":"0px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_ctx.arrExpeditii.length==0 && !_ctx.loadingExpeditii)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Nicio expeditie"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrExpeditii, (expeditie, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "expeditie"
                    }, [
                      (_ctx.user.auth_for_expeditie=='y' && _ctx.isAllowOperator)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_q_icon, {
                              name: "delete_forever",
                              class: "text-red cursor-pointer",
                              style: {"font-weight":"bold","position":"relative","font-size":"1.3rem","top":"-2px"},
                              onClick: ($event: any) => (_ctx.removeExpeditie(expeditie,index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, {
                                  "transition-show": "rotate",
                                  "transition-hide": "rotate"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sterge expeditia!")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(expeditie.awb_nr) + "/" + _toDisplayString(expeditie.awb_data) + " " + _toDisplayString(expeditie.awb_detalii), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          })
        ]))
  ]))
}